import React, { useState } from 'react';
import Overlay from 'shared/Overlay';

import InputGroupComponent from 'components/groups/InputGroup';
import { VARIANT } from 'constants/inputTypes';

export interface BasePriceOverlayProps {
  onCloseClick: (event: React.MouseEvent) => void;
  onPrimaryClick: (event: React.MouseEvent, value: string) => void;
  warehouseName: string;
  receptionDate: string;
  currencySymbol: string;
  errors: string[];
  saving: boolean;
}

// PLA-1086: captura del precio base que rige para la fecha de recibimiento del lote.
// La fecha se muestra deshabilitada porque no es editable: la define el lote, no el usuario.
const BasePriceOverlay: React.FC<BasePriceOverlayProps> = ({
  onCloseClick,
  onPrimaryClick,
  warehouseName,
  receptionDate,
  currencySymbol,
  errors,
  saving,
}) => {
  const [value, setValue] = useState('');

  // Se acepta sólo un decimal positivo: el backend revalida (API::V1::CreateBasePriceForm), pero
  // sin esto el usuario descubre el error recién después de enviarlo.
  const isValid = /^\d+(\.\d+)?$/.test(value.trim()) && parseFloat(value) > 0;

  const handleOnPrimaryClick = (event: React.MouseEvent) => {
    if (!isValid || saving) return;

    onPrimaryClick(event, value.trim());
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  return (
    <Overlay
      primaryText={I18n.translate('accept_price.index.base_price.overlay.primary')}
      onPrimaryClick={handleOnPrimaryClick}
      primaryDisabled={!isValid || saving}
      secondaryText={I18n.translate('accept_price.index.base_price.overlay.secondary')}
      onSecondaryClick={onCloseClick}
      title={warehouseName}
    >
      <InputGroupComponent
        data-cy={'reception_date'}
        label={I18n.translate('accept_price.index.base_price.overlay.date_label')}
        value={receptionDate}
        onChange={() => undefined}
        disabled
        name='reception_date'
      />

      <InputGroupComponent
        data-cy={'base_price'}
        label={I18n.translate('accept_price.index.base_price.overlay.label')}
        variant={VARIANT.DECIMAL}
        onChange={handleOnChange}
        value={value}
        append={currencySymbol}
        errors={errors}
        required
        name='base_price'
      />

      <p className='input-group__hint'>
        {I18n.translate('accept_price.index.base_price.overlay.hint')}
      </p>
    </Overlay>
  );
};

export default BasePriceOverlay;
